import { render, staticRenderFns } from "./manageMediaTemplate.vue?vue&type=template&id=30f504ce&"
import script from "./manageMediaTemplate.vue?vue&type=script&lang=ts&"
export * from "./manageMediaTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports